<script>
  import {createEventDispatcher, getContext, onMount} from 'svelte';
  import {PATHS, LINKS} from '@/const';
  import {fixLink$} from '@/store';
  import {sd} from '@/da/sd';
  import {spotBotsIsGray$} from '@/modules/strategy/strategy-square/streams';
  import {spotMarkets$} from '@/modules/markets/streams-market';
  import {crossLeverage$} from '@/streams/config/margin-trade';
  import {userInfo$} from '@/store';
  import {isSupportMarginTrading$} from '@/streams/margin-trade';
  import {memeQuery$} from '@/streams/config/MemeX';
  import Menu from '@/widgets/trigger/Menu.svelte';
  import MenuItemView from '../components/MenuItemView.svelte';
  import SpotMarketDropDown from '@/modules/header/popups/spot/SpotMarketDropDown.svelte';
  import lang from '../../Header.lang';

  const LG = getContext('LG');
  const excludeMenu = ['spot_trading', 'margin_trading', 'MemeTrading'];

  const dispatch = createEventDispatcher();

  let innerHeight;
  let componentRef;
  let hasSubSet = false;

  const modifiers = [
    {
      name: 'flip',
      enabled: false, // 禁用 flip 修饰符，防止自动调整位置
    },
    {
      name: 'offset',
      options: {
        offset: [0, 0],
      },
    },
    {
      name: 'preventOverflow',
      options: {
        padding: 0,
      },
    },
  ];

  $: userInfo = $userInfo$;

  onMount(() => {
    innerHeight = componentRef.getBoundingClientRect().height;
  });

  function handleSpotClickFuc(item) {
    return function () {
      if (item === 'convert') {
        sd.track('convert_transfer_button_click', {ui_position: 'exchange', $element_content: 'convert'});
      }
      if (item === 'MemeTrading') {
        sd.track('memex_homgepage_view', {page_name: 'memex_homepage'});
      }
      sd.track('web_click', {$screen_name: 'home', $element_content: 'navigation_spot_' + item});
    };
  }

  function handleMMXClear() {
    memeQuery$.next({
      orderBy: 'Gainers',
      pageNum: 1,
      // 取大，主要给header mmx搜索拿全量数据使用
      pageSize: 10,
    });
  }

  function handleMouseEnterForNext(menuName) {
    // 删除默认active状态
    if (menuName !== 'spot_trading') {
      const elem = document.querySelector(`.spot-menu-trade`);
      elem.classList.remove('active');
    }
    hasSubSet = excludeMenu.includes(menuName);
    dispatch('hover', hasSubSet);
  }

  function handleMouseLevel(e) {
    if (e.target.classList.contains('spot-group') || e.target.classList.contains('common-item-wrap')) {
      hasSubSet = false;
    }
  }
</script>

<style>
  .wrap {
    box-sizing: border-box;
    border-bottom-right-radius: 12px;
    border-bottom-left-radius: 12px;
    width: 328px;
    cursor: default;
    backdrop-filter: blur(10px);
  }
  .wrap-subset {
    border-bottom-right-radius: 12px;
    padding-right: 344px;
    width: 672px;
  }
  .wrap .spot-group {
    padding-bottom: 16px;
    background: rgba(26, 29, 31, 0.96);
  }
  .spot-market-menu {
    width: 100%;
  }
  :global(.spot-menu-trade.active .menu-item) {
    background: rgba(255, 255, 255, 0.06);
  }
</style>

<div class="wrap df fdc T2 ovh" class:wrap-subset={hasSubSet} bind:this={componentRef}>
  <div class="spot-group df fdc" on:mouseover={handleMouseLevel}>
    <Menu class="spot-market-menu" triggerClass="spot-menu-trade" duration={0} placement="right-start" {modifiers} noIcon on:mouseenter={handleMouseEnterForNext.bind(null, 'spot_trading')}>
      <div slot="trigger" class="f1 wp100 ph16 ovh pt16">
        <MenuItemView
          theme="dark"
          iconUrl="https://img.phemex.com/v1/f5dcf1ad-bdcd-4562-9230-7c09c1aeacc5/property-1-spot-trading.svg"
          iconAlt="spot"
          link={$fixLink$(LINKS.PHEMEX_SPOT_TRADE)}
          target="_self"
          title={LG(lang.SpotTrading)}
          noArrowHover
          subTitle={LG(lang.OnlyOpenTo, {TradePairNumber: $spotMarkets$.length})}
          on:click={handleSpotClickFuc('spot_trading')}
        />
      </div>
      <SpotMarketDropDown name="spot_trading" categoryId="" {innerHeight} />
    </Menu>

    {#if $isSupportMarginTrading$}
      <Menu class="spot-market-menu" duration={0} placement="right-start" {modifiers} noIcon on:mouseenter={handleMouseEnterForNext.bind(null, 'margin_trading')}>
        <div slot="trigger" class="f1 wp100 ph16 ovh">
          <MenuItemView
            theme="dark"
            iconUrl="https://img.phemex.com/v1/5625d624-d74e-46e8-ba24-e2d3fc3fc8e1/property-1-margin.svg"
            iconAlt="spot"
            link={$fixLink$(LINKS.PHEMEX_SPOT_MARGIN_TRADE)}
            target="_self"
            title={LG(lang.MarginTradingMenuTitle) + ' ' + $crossLeverage$ + 'X'}
            titleIconAlt="new"
            noArrowHover
            subTitle={LG(lang.MarginTradingMenuDesc)}
            on:click={handleSpotClickFuc('margin_trading')}
          />
        </div>
        <SpotMarketDropDown name="margin_trading" categoryId="" {innerHeight} />
      </Menu>
    {/if}
    {#if userInfo.isMain}
      <Menu class="spot-market-menu" duration={0} placement="right-start" {modifiers} noIcon on:mouseenter={handleMouseEnterForNext.bind(null, 'MemeTrading')} on:mouseleave={handleMMXClear}>
        <div slot="trigger" class="f1 wp100 ph16 ovh">
          <MenuItemView
            theme="dark"
            iconUrl="https://img.phemex.com/v1/614be2e0-cf2d-47f3-a401-b4dc13ef5877/property-1-meme-x.svg"
            iconAlt="meme trade"
            link={$fixLink$(LINKS.PHEMEX_MEME_TRADE)}
            target="_self"
            title={LG(lang.Memex)}
            titleIcon="https://img.phemex.com/v1/c80564dc-92f8-4e33-bcd6-a9e383b8857d/new.svg"
            subTitle={LG(lang.InstantlyTrade)}
            noArrowHover
            on:click={handleSpotClickFuc('MemeTrading')}
          />
        </div>
        <SpotMarketDropDown name="MemeTrading" categoryId="" {innerHeight} />
      </Menu>
    {/if}
    <div class="common-item-wrap ph16">
      <MenuItemView
        theme="dark"
        iconUrl="https://img.phemex.com/v1/41b917e4-dad9-4052-9f36-00646b0f379e/property-1-convert.svg"
        iconAlt="contract"
        link={$fixLink$(PATHS.CRYPTO_CONVERTER.pathname)}
        target="_self"
        title={LG(lang.Convert)}
        subTitle={LG(lang.TheEasiestWayToTrade)}
        noArrow
        on:click={handleSpotClickFuc('convert')}
        on:mouseenter={handleMouseEnterForNext.bind(null, 'Convert')}
      />
    </div>
    <div class="common-item-wrap ph16">
      <MenuItemView
        theme="dark"
        iconUrl="https://img.phemex.com/v1/4f752ad5-6273-4d28-94e9-3bed7e3a0703/property-1-launchpad.svg"
        iconAlt="launchpad"
        link={$fixLink$(PATHS.LAUNCHPAD.pathname)}
        target="_self"
        title={LG(lang.Launchpad)}
        subTitle={LG(lang.LaunchpadDesc)}
        noArrow
        on:click={handleSpotClickFuc('launchpad')}
        on:mouseenter={handleMouseEnterForNext.bind(null, 'launchpad')}
      />
    </div>
    {#if $spotBotsIsGray$}
      <div class="common-item-wrap ph16">
        <MenuItemView
          theme="dark"
          iconUrl="https://img.phemex.com/v1/cb9bb76d-cb12-41ae-ae52-d8e6d203ad97/property-1-trading-bot.svg"
          iconAlt="strategy square"
          link={$fixLink$(PATHS.STRATEGY_SQUARE.pathname) + '?type=SPOT_GRID'}
          target="_self"
          title={LG(lang.TradingBots)}
          titleIconAlt="new"
          subTitle={LG(lang.IntelligentTrading)}
          noArrow
          on:click={handleSpotClickFuc('trading_bots')}
          on:mouseenter={handleMouseEnterForNext.bind(null, 'trading_bots')}
        />
      </div>
    {/if}
  </div>
</div>
